import { jsx } from 'react/jsx-runtime';
import cns from '../../../../node_modules/classnames/index.js';
import useModalContext from './useModalContext.js';

/**
 * Corpo della modale.
*/
function Body({ className, children, scrollable = false }) {
    const { overflow, maxHeight } = useModalContext();
    return (jsx("div", { className: cns('v2-modal__body', { 'v2-modal--body--scrollable': scrollable }, className), style: { overflow, maxHeight }, children: children }));
}

export { Body as default };
